/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Title_LeadInputs */

const en_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps &`)
};

const es_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Campamentos y`)
};

const de_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps &`)
};

const zh_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`训练营与`)
};

const ar_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المعسكرات و`)
};

const fr_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps et`)
};

const vi_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trại và`)
};

const sw_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kambi na`)
};

const th_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แคมป์และ`)
};

const bs_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampovi i`)
};

const ja_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンプ&`)
};

const ko_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`캠프 &`)
};

const pt_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acampamentos e`)
};

const it_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camp e`)
};

const sv_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Läger och`)
};

const nl_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampen &`)
};

const da_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camps og`)
};

const nb_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leirer og`)
};

const fi_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leirit ja`)
};

const pl_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obozy i`)
};

const ru_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Лагеря и`)
};

const tr_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamplar ve`)
};

const hi_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कैंप और`)
};

const id_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamp &`)
};

const ms_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kem &`)
};

const cs_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kempy a`)
};

const el_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κατασκηνώσεις &`)
};

const he_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחנות`)
};

const af_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kampe en`)
};

const hu_events_title_lead = /** @type {(inputs: Events_Title_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Táborok és`)
};

/**
* | output |
* | --- |
* | "Camps &" |
*
* @param {Events_Title_LeadInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_title_lead = /** @type {((inputs?: Events_Title_LeadInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Title_LeadInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_title_lead(inputs)
	if (locale === "de") return de_events_title_lead(inputs)
	if (locale === "zh") return zh_events_title_lead(inputs)
	if (locale === "ar") return ar_events_title_lead(inputs)
	if (locale === "fr") return fr_events_title_lead(inputs)
	if (locale === "vi") return vi_events_title_lead(inputs)
	if (locale === "sw") return sw_events_title_lead(inputs)
	if (locale === "th") return th_events_title_lead(inputs)
	if (locale === "bs") return bs_events_title_lead(inputs)
	if (locale === "ja") return ja_events_title_lead(inputs)
	if (locale === "ko") return ko_events_title_lead(inputs)
	if (locale === "pt") return pt_events_title_lead(inputs)
	if (locale === "it") return it_events_title_lead(inputs)
	if (locale === "sv") return sv_events_title_lead(inputs)
	if (locale === "nl") return nl_events_title_lead(inputs)
	if (locale === "da") return da_events_title_lead(inputs)
	if (locale === "nb") return nb_events_title_lead(inputs)
	if (locale === "fi") return fi_events_title_lead(inputs)
	if (locale === "pl") return pl_events_title_lead(inputs)
	if (locale === "ru") return ru_events_title_lead(inputs)
	if (locale === "tr") return tr_events_title_lead(inputs)
	if (locale === "hi") return hi_events_title_lead(inputs)
	if (locale === "id") return id_events_title_lead(inputs)
	if (locale === "ms") return ms_events_title_lead(inputs)
	if (locale === "cs") return cs_events_title_lead(inputs)
	if (locale === "el") return el_events_title_lead(inputs)
	if (locale === "he") return he_events_title_lead(inputs)
	if (locale === "af") return af_events_title_lead(inputs)
	if (locale === "hu") return hu_events_title_lead(inputs)
	return en_events_title_lead(inputs)
});